<div fxFlex="column" class="unassign-dialog">

    <div class="dialog-header">
        Unassign - {{ studentName }}
    </div>

    <div class="unassign-container" fxLayout="column">
        <div class="unassign-question">
            Unassign {{lessonName}} from {{studentName}}?
        </div>
            <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
            <div>
                <button
                    class="cancel-button button"
                    mat-button
                    type="button"
                    (click)="onCancel()"
                >
                    Cancel
                </button>
            </div>
            <div>
                <button
                class="submit-button button"
                mat-button
                type="button"
                (click)="onUnassign()"
            >
                Unassign
            </button>
            </div>
        </div>
    </div>
</div>
